import { render, staticRenderFns } from "./CurrentPatient.vue?vue&type=template&id=0d03919c&scoped=true&"
import script from "./CurrentPatient.vue?vue&type=script&lang=js&"
export * from "./CurrentPatient.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPatient.vue?vue&type=style&index=0&id=0d03919c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d03919c",
  null
  
)

export default component.exports